export enum AvailableKpis {
  maintenanceCompletion = 'maintenanceCompletion',
  maintenanceVisit = 'maintenanceVisit',
  emergencyCalls = 'emergencyCalls',
  callbacks = 'callbacks',
}

export type AvailableKpisType = keyof typeof AvailableKpis;

const getKpiFilter = (allowedKPIs: AvailableKpisType[]) => {
  return (kpiToTest: AvailableKpisType) => allowedKPIs.includes(kpiToTest);
};

export default getKpiFilter;
